var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full flex", on: { mouseleave: _vm.closeSubmenu } },
    [
      _c("div", { staticClass: "w-1/2" }, [
        _c(
          "ul",
          _vm._l(_vm.navItems, function(navItem, navItemIndex) {
            return _c(
              "li",
              {
                key: navItem.id,
                class: [
                  "flex justify-between items-center p-2 rounded-md hover:bg-secondary",
                  {
                    "mt-2": navItemIndex !== 0,
                    "bg-secondary": _vm.selectedNavItemId === navItem.id
                  }
                ],
                on: {
                  mouseover: function($event) {
                    return _vm.openSubmenu(navItem.id)
                  }
                }
              },
              [
                _c("div", { staticClass: "flex items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-[84px] border-1 border-solid border-grey-600 rounded-md"
                    },
                    [
                      _c("div", { staticClass: "aspect-w-4 aspect-h-3" }, [
                        navItem.transformedImages !== null
                          ? _c("picture", [
                              _c("source", {
                                attrs: {
                                  "data-srcset":
                                    navItem.transformedImages[0].url,
                                  type: "image/webp"
                                }
                              }),
                              _vm._v(" "),
                              _c("source", {
                                attrs: {
                                  "data-srcset":
                                    navItem.transformedImages[1].url,
                                  type: "image/jpeg"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass:
                                  "w-full h-full object-center object-cover",
                                attrs: {
                                  src: navItem.transformedImages[1].url,
                                  alt: navItem.transformedImages[1].title
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        navItem.svgImage !== null
                          ? _c("img", {
                              directives: [{ name: "lazy", rawName: "v-lazy" }],
                              staticClass:
                                "w-full h-full object-cover object-center",
                              attrs: {
                                src: navItem.svgImage.url,
                                alt: navItem.svgImage.title
                              }
                            })
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "px-4" }, [
                    navItem.url !== null
                      ? _c(
                          "a",
                          {
                            class: [
                              "u-body-md group relative inline-block text-primary-navy font-bold focus:outline-none",
                              navItem.classes,
                              {
                                "cursor-default": !navItem.url
                              }
                            ],
                            attrs: {
                              href: navItem.url,
                              target: navItem.newWindow ? "_blank" : "_self"
                            }
                          },
                          [
                            _c("span", {
                              class: [
                                "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                              ]
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: [
                                  "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(navItem.title) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "p",
                          {
                            class: [
                              "u-body-md group relative inline-block text-primary-navy font-bold focus:outline-none",
                              navItem.classes
                            ]
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(navItem.title) +
                                "\n            "
                            )
                          ]
                        ),
                    _vm._v(" "),
                    _vm.isCommunityType
                      ? _c("p", { staticClass: "u-body-sm" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(navItem.children.length) +
                              " Communities\n            "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.17952 2.64098L11.359 7.8205L6.17952 13",
                        stroke: "#0B2537",
                        "stroke-width": "2"
                      }
                    })
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-1/2" },
        [
          _c(
            "transition",
            {
              key: "megamenu-" + _vm.selectedNavItemId,
              attrs: {
                appear: "",
                "enter-class": "menu-enter",
                "enter-active-class": "menu-enter-active",
                "enter-to-class": "menu-enter-to",
                "leave-class": "menu-leave",
                "leave-active-class": "menu-leave-active",
                "leave-to-class": "menu-leave-to"
              }
            },
            [
              _vm.selectedNavItem !== null &&
              _vm.selectedNavItem.children.length > 0
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-secondary mx-6 pt-4 pb-8 px-6 rounded-lg"
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "u-body font-bold mb-2" },
                          [
                            _vm.isCommunityType
                              ? [_vm._v("Choose a community")]
                              : _vm.isHomesType
                              ? [_vm._v("Narrow down your criteria")]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "mb-3" },
                          _vm._l(_vm.selectedNavItem.children, function(
                            childItem,
                            childItemIndex
                          ) {
                            return _c(
                              "li",
                              {
                                key: childItem.id,
                                class: [
                                  "",
                                  {
                                    "mt-3": childItemIndex !== 0
                                  }
                                ]
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    class: [
                                      "u-body-md group relative inline-block text-primary-navy focus:outline-none",
                                      childItem.classes,
                                      {
                                        "cursor-default": !childItem.url
                                      }
                                    ],
                                    attrs: {
                                      href: childItem.url,
                                      target: childItem.newWindow
                                        ? "_blank"
                                        : "_self"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      class: [
                                        "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                      ]
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(childItem.title) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    childItem.tag !== null
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "u-body-sm font-bold bg-white border-1 border-solid border-grey-700 py-1 px-2 rounded-md ml-2"
                                          },
                                          [_vm._v(_vm._s(childItem.tag))]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.selectedNavItem.url !== null
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "relative inline-flex flex-nowrap items-center font-circular font-bold text-sm leading-base group focus:outline-none",
                                attrs: {
                                  href: _vm.selectedNavItem.url,
                                  target: _vm.selectedNavItem.newWindow
                                    ? "_blank"
                                    : "_self"
                                }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "absolute -inset-1.5 opacity-0 group-focus:opacity-100 border-2 border-grey-900 border-solid rounded-lg transition-opacity duration-200 ease-in-out pointer-events-none"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-grey-800 border-b-2 border-grey-800 border-solid transition duration-200 ease-in-out group-hover:border-transparent"
                                  },
                                  [
                                    _vm._v(
                                      "\n              View all\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "w-6 h-6 ml-3" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "overflow-visible",
                                      attrs: {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }
                                    },
                                    [
                                      _c("circle", {
                                        staticClass:
                                          "fill-current text-primary-200",
                                        attrs: { cx: "12", cy: "12", r: "12" }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        staticClass:
                                          "fill-current text-grey-800 transition duration-200 ease-in-out transform group-hover:translate-x-3",
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          "clip-rule": "evenodd",
                                          d:
                                            "M14.6776 7.20438C14.287 6.81385 13.6539 6.81385 13.2634 7.20438C12.8728 7.5949 12.8728 8.22807 13.2634 8.61859L15.6448 11L6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13L15.5858 13L13.2634 15.3224C12.8728 15.713 12.8728 16.3461 13.2634 16.7367C13.6539 17.1272 14.287 17.1272 14.6776 16.7367L18.7366 12.6776C19.1271 12.2871 19.1271 11.6539 18.7366 11.2634L14.6776 7.20438Z"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }